import type { TranslationInterface } from '.';

export const EstonianLanguage: TranslationInterface = {
  write_a_message_placeholder: 'Kirjuta sõnum...',
  your_issue_has_been_resolved: 'Teie probleem on lahendatud!',
  new_conversation: 'Uus vestlus',
  welcome_screen_title: 'Tere tulemast meie tugiteenusesse',
  welcome_screen_description:
    'Oleme siin, et aidata! Alustage vestlust ja vastame teile esimesel võimalusel.',
  your_name_placeholder: 'Teie nimi',
  your_email_placeholder: 'Teie e-posti aadress',
  start_chat_button: 'Räägi toega',
  start_chat_button_loading: 'Ühendamine...',
  i_need_more_help: 'Vajan rohkem abi',
  this_was_helpful: 'See oli kasulik',
  optional: 'Valikuline',
  no_conversations_yet: 'Vestlusi pole veel',
  back_to_conversations: 'Tagasi vestluste juurde',
  closed_conversations: 'Suletud vestlused',
  csat_title: 'Milline oli teie vestlus?',
  csat_submitted_title: 'Hindasite vestlust kui',
  csat_feedback_placeholder: 'Rääkige meile rohkem... (valikuline)',
  follow_up_placeholder: 'Küsi juurde…',
  companion_layout_label: 'Paigutus',
  companion_layout_floating: 'Hõljuv',
  companion_layout_sidebar: 'Külgriba',
  companion_layout_fullscreen: 'Täisekraan',
  companion_close: 'Sulge',
  companion_history: 'Vestluste ajalugu',
  companion_expand_chat: 'Laienda vestlust',
  companion_sidebar_dock_label: 'Dokk',
  companion_sidebar_side_label: 'Külg',
  companion_sidebar_left: 'Vasak',
  companion_sidebar_right: 'Parem',
  companion_resize_chat: 'Muuda vestluse suurust',
  scroll_to_bottom: 'Keri alla',
  thinking: 'Mõtlen…',
  running: 'Töötab…',
  steps: 'sammud',
  step_arguments: 'Argumendid',
  step_result: 'Tulemus',
  attach_files:
    'Lisa pilte, videoid, PDF-e või arvutustabeleid (maksimaalne suurus 25 MB)',
  mark_page_active:
    'Märkimiseks klõpsa lehel ükskõik millel — tühistamiseks vajuta Esc',
  mark_page: 'Märgi lehel midagi, et selle kohta küsida',
  stop_response: 'Peata vastus',
  copy_reply: 'Kopeeri vastus',
  mentions_empty: 'Vasteid pole',
  copied: 'Kopeeritud',
  send_message: 'Saada sõnum',
  upload_failed: 'Üleslaadimine nurjus: {error}',
  remove_attachment: 'Eemalda manus',
  json_no_items: 'Üksusi pole',
  json_no_data: 'Andmeid pole',
  json_no_chart_data: 'Diagrammi jaoks pole andmeid',
  json_unsupported: 'Pole toetatud: {type}',
  json_see_less: 'Näita vähem',
  json_phone_agent: 'Telefoniagent',
  json_phone_agent_test: 'Testi veebis',
  page_context_remove: 'Eemalda lehe kontekst',
  json_see_more: 'Näita veel {count}',
  queued_label: '{count} Järjekorras',
  remove_queued_message: 'Eemalda sõnum järjekorrast',
  send_queued_now: 'Saada järjekorras olevad sõnumid kohe',
  turn_failed_message: 'Midagi läks valesti ja vastus ei saabunud.',
  turn_failed_retry: 'Proovi uuesti',
  page_mark_hint: 'Märkimiseks klõpsa millelgi',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'Kast',
  page_mark_shape_circle: 'Ring',
  page_mark_shape_arrow: 'Nool',
  page_mark_shape_bracket: 'Sulg',
  page_mark_shape_underline: 'Allajoonimine',
  page_mark_shape_highlight: 'Esiletõst',
  page_mark_shape_strike_through: 'Läbikriipsutus',
  page_mark_shape_crossed_off: 'Ristiga maha tõmbamine',
  page_mark_shape_aria: 'Märke kuju: {shape}',
  page_mark_note_placeholder: 'Lisa märkus… (Enter lisamiseks)',
  page_mark_attach: 'Lisa märge',
  page_mark_remove: 'Eemalda {label}',
  page_mark_region: 'Märgitud ala',
  page_mark_default_message: 'Mis see on?',
  file_rejected: 'Failitüüpi ei toetata või fail on liiga suur.',
  dictate: 'Dikteeri',
  stop_dictation: 'Lõpeta dikteerimine',
  dictation_mic_blocked: 'Dikteerimiseks luba mikrofoni kasutamine',
  dictation_unavailable: 'Dikteerimine pole praegu saadaval',
  questions_back: 'Tagasi',
  questions_next: 'Edasi',
  questions_send: 'Saada',
  questions_type_answer: 'Kirjutan ise',
  questions_answer_placeholder: 'Kirjutage oma vastus…',
  close_conversation_title: 'Sulge vestlus',
  close_conversation_description:
    'Kas soovite kindlasti selle vestluse sulgeda?',
  close_conversation_cancel: 'Ei',
  close_conversation_confirm: 'Jah',
  dialog_close: 'Sulge',
  zoom_in: 'Suurenda',
  zoom_out: 'Vähenda',
  reset_zoom: 'Lähtesta suurendus',
  support_chat_aria_label: 'Tugivestlus',
};
